import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionTitle: {
    description: 'Title for the section used to configure shipment options such as dimensions, weight, carrier, etc.',
    defaultMessage: 'Configure Shipment',
    id: 'X/lOFN',
  },
  sectionAriaLabel: {
    description: 'Aria label for the expandable configure shipment section',
    defaultMessage: 'Configure Shipment expander section',
    id: 'Mw+6VE',
  },
  preset: {
    description:
      'Label for the "Preset" dropdown, used to apply and manage presets. A "Preset" is a user built shipment configuration (Service, dimensions, weight, etc.) that can be applied to a shipment.',
    defaultMessage: 'Preset',
    id: 'TfN1ze',
  },
  shipDate: {
    description: 'Label for when the shipment should be shipped. Either "Today" or the give date.',
    defaultMessage: 'Ship {isToday, select, true {Today} other {{date}}}',
    id: 'QxE8eV',
  },
  scale: {
    description: 'Text for a button used to read the current weight from a scale',
    defaultMessage: 'Scale',
    id: 't6xUvN',
  },
  demoTooltipText: {
    description: 'Tooltip text for the demo green star on the Configure Shipment section',
    defaultMessage: 'Set your ship from location, package weight, service, dimensions, and other options to get accurate shipping rates.',
    id: 'CjAA6l',
  },
  demoTooltipAltText: {
    description: 'Alt text for the demo green star on the Configure Shipment section',
    defaultMessage: 'Green star tooltip explaining the Configure Shipment area',
    id: 'HQD+An',
  },
});
